<template>
  <div class="column content-box settings--content">
    <label>
      {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.DOMAINS.LABEL') }}
    </label>
    <div v-if="!modelAcceptDomains" class="alert-info-model-domains">
      <fluent-icon icon="info" size="35" />
      <span
        v-dompurify-html="
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.DOMAINS.ALERT_MODEL_TEXT', {
            models: modelsAcceptDomains.join(', '),
          })
        "
      />
    </div>
    <div v-else>
      <input
        v-model.trim="domain"
        type="text"
        name="domain"
        :placeholder="
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.DOMAINS.PLACEHOLDER')
        "
        @keydown.enter.prevent="addDomain"
      />
      <woot-button
        type="button"
        class="button--add-domain"
        icon="add"
        color-scheme="success"
        variant="smooth"
        size="small"
        :disabled="domain.trim() == ''"
        @click="addDomain"
      >
        <span>{{
          $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.DOMAINS.BUTTON_ADD_TEXT')
        }}</span>
      </woot-button>
      <ul v-if="domains.length > 0" class="domain-list">
        <li v-for="(item, index) in domains" :key="index">
          <span>{{ item }}</span>
          <woot-button
            type="button"
            class="button--remove-domain"
            icon="dismiss-circle"
            color-scheme="alert"
            variant="smooth"
            size="small"
            @click="removeDomain(index)"
          />
        </li>
      </ul>
    </div>

    <div class="tab-footer">
      <woot-submit-button
        :disabled="$v.$invalid"
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import assistentTabMixin from '../../mixins/assistentTabMixin';

const modelsAcceptDomains = ['gpt-5.4', 'gpt-5.5', 'gpt-5.6-sol', 'gpt-5.6-terra', 'gpt-5.6-luna', 'gpt-6-sol', 'gpt-6-luna'];

export default {
  mixins: [assistentTabMixin],
  data() {
    return {
      domain: '',
      domains: JSON.parse(JSON.stringify(this.assistent.domains || [])),
    };
  },
  validations: {
    domains: {
      domainList(value) {
        return value.every(domain => {
          const domainPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
          return domainPattern.test(domain);
        });
      },
    },
  },
  computed: {
    modelsAcceptDomains() {
      return modelsAcceptDomains;
    },
    modelAcceptDomains() {
      return (
        this.assistent.model &&
        modelsAcceptDomains.includes(this.assistent.model)
      );
    },
  },
  methods: {
    extractHost(value) {
      let host = value;
      try {
        if (host.includes('://')) {
          host = new URL(host).hostname;
        } else if (host.includes('/')) {
          host = new URL(`http://${host}`).hostname;
        }
      } catch (e) {
        host = host.replace(/^https?:\/\//, '').split('/')[0];
      }
      return host;
    },
    addDomain() {
      const input = this.domain.trim();
      if (!input) return;
      const domain = this.extractHost(input);
      if (!domain) return;
      if (!this.domains.includes(domain)) {
        this.domains.push(domain);
        this.domain = '';
      }
    },
    removeDomain(index) {
      this.domains.splice(index, 1);
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      await this.saveAssistent({ domains: this.domains });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
